<script>
import baseMixin from '@/mixins/baseMixin'
import BaseLogo from '@/components/_base-logo.vue'
import LogoForm from '@/constants/assets/LogoForm'
import LogoShade from '@/constants/assets/LogoShade'

export default {
  name: 'TheAppLogo',
  components: {
    BaseLogo,
  },
  mixins: [baseMixin],
  props: {
    form: {
      type: String,
      default: LogoForm.NONE,
    },
  },
  computed: {
    compShade() {
      return this.isDarkMode ? LogoShade.LIGHT : LogoShade.DARK
    },
  },
}
</script>

<template>
  <BaseLogo v-bind="$attrs" :form="form" :shade="compShade" v-on="$listeners" />
</template>
